module.exports = __webpack_public_path__ + "static/media/web.6577fe83.config";